// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pGpg","newExpiryDate":"styles_newExpiryDate__gXYQI","footer":"styles_footer__1mBsK"};